<template>
  <div>
    <v-card class="pt-3 pb-3 mt-12">
      <v-row>
        <v-card-title>
          <h2 class="text-xl">Données Google Search Console</h2>
          <!-- <dag-info :dags="['gtrends_realtime_dag']" /> -->
        </v-card-title>
        <dot-menu
          :isLoading="isLoading"
          @exportExcel="exportExcel"
          :position="'page-top-right'"
          :excelButton="{
            excelData,
            filename: `Gsc-Monthly-${startDate}_${endDate}.xlsx`,
          }"
        ></dot-menu>
      </v-row>

      <Loader v-if="isLoading"></Loader>

      <v-row>
        <v-col cols="12">
          <v-data-table class="ml-6 mr-6" :items="items" :headers="headers">
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<style scoped></style>

<script>
import DotMenu from "@/components/common/menus/DotMenu.vue";
import DagInfo from "@/components/common/menus/DagInfo.vue";
import Loader from "@/components/common/Loader.vue";
import useAxios from "@/hooks/useAxios";
import { mdiMagnify, mdiOpenInNew } from "@mdi/js";

export default {
  name: "gscMonthlyTable",
  components: {
    DagInfo,
    Loader,
    DotMenu,
  },

  data() {
    return {
      icons: {
        mdiOpenInNew,
        mdiMagnify,
      },
      items: [],
      headers: [
        {
          text: "month",
          value: "month",
          sortable: true,
        },
        {
          text: "site",
          value: "site.name",
          sortable: true,
        },
        {
          text: "clicks",
          value: "clicks",
          sortable: true,
        },
        {
          text: "impressions",
          value: "impressions",
          sortable: true,
        },
        {
          text: "ctr",
          value: "ctr",
          sortable: true,
        },
      ],
      isFetching: false,
      excelData: new Blob([""], { type: "text/plain" }),
    };
  },

  setup() {
    const { axiosGet, axiosPost, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
    };
  },

  methods: {
    async getData() {
      if (this.isFetching) {
        console.debug("Appel getData ignoré (déjà en cours)");
        return;
      } // empêche les doublons
      this.isFetching = true;
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
        gsc_source_id: this.gscSourceId,
        site_ids: this.sites.join(","),
      };
      const response = await this.axiosGet("/gsc_monthly", params);
      this.items = response.data;
      this.isFetching = false;
    },
    async exportExcel() {
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
        site_ids: this.sites.join(","),
      };
      const response = await this.axiosGet("/gsc_monthly/excel", params, {
        responseType: "blob",
      });
      this.excelData = response.data;
    },
  },
  async created() {},
  computed: {
    filtersApplied() {
      return this.$store.getters["common/getApplyFilters"];
    },
    sites() {
      return this.$store.getters["audience/getSites"];
    },
    startDate() {
      return this.$store.getters["audience/getSelectedGscDateRange"][0];
    },
    endDate() {
      return this.$store.getters["audience/getSelectedGscDateRange"][1];
    },
    gscSourceId() {
      return this.$store.getters["audience/getGscSourceType"];
    },
  },
  watch: {
    filtersApplied(newVal) {
      if (!newVal) return;
      this.getData();
      this.$store.dispatch("common/updateApplyFilters", false);
    },
  },
};
</script>
